/**
 * Energy Row Scroll Functionality
 * Shows/hides the gradient fade based on scroll position
 */
(function() {
  'use strict';

  document.querySelectorAll('[data-section-type="energy-row"]').forEach(function(section) {
    var container = section.querySelector('.energy-scroll-container');
    var scroll = section.querySelector('[data-energy-scroll]');

    if (scroll && container) {
      scroll.addEventListener('scroll', function() {
        var isAtEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 10;
        container.classList.toggle('scrolled-end', isAtEnd);
      }, { passive: true });
    }
  });
})();
